import React from 'react';
import { Box } from '@material-ui/core';

import PaymentSettingsProvider from 'components/context/PaymentSettings/PaymentSettingsProvider';
import BookingProvider from './context/BookingProvider';
import CarProvider from './context/CarProvider';
import TopBar from './components/TopBar';
import CarDetails from './components/CarDetails';
import HasBookingInRangeProvider from './context/HasBookingInRangeProvider';

const Car = () => {
	return (
		<PaymentSettingsProvider>
			<CarProvider>
				<HasBookingInRangeProvider>
					<BookingProvider>
						<Box>
							<TopBar />
							<CarDetails />
						</Box>
					</BookingProvider>
				</HasBookingInRangeProvider>
			</CarProvider>
		</PaymentSettingsProvider>
	);
};

export default Car;
